import React, { useContext, useEffect, useState } from "react";
import useGetTagKeys from "../../api/tagKeys";

import './tags-right-panel.styles.scss';
import useFetch from "../../api/fetch";
import { Link } from "react-router-dom";



export default function TagsRightPanel({tag}) {
    const initialDnDState = {
        draggedFrom: null,
        draggedTo: null,
        isDragging: false,
        originalOrder: [],
        updatedOrder: []
    };

    const getTagKeys = useGetTagKeys();
    const fetch = useFetch();
    const [tagKeys, setTagKeys] = useState([]);
    const [showSave, setShowSave] = useState(false);
    const [dragAndDrop, setDragAndDrop] = useState( initialDnDState );

    const onDragStart = (e) => {
        const initialPosition = Number(e.currentTarget.dataset.position);

        setDragAndDrop({
            ...dragAndDrop,
            draggedFrom: initialPosition, // set the draggedFrom position
            isDragging: true,
            originalOrder: tagKeys // store the current state of "tagKeys"
        });

        // Note: this is only for Firefox.
        // Without it, the DnD won't work.
        // But we are not using it.
        e.dataTransfer.setData("text/html", '');
    };

    const onDragOver = (e) => {
        e.preventDefault();
        let newList = dragAndDrop.originalOrder;

        const draggedFrom = dragAndDrop.draggedFrom;
        const draggedTo = Number(e.currentTarget.dataset.position);
        const itemDragged = newList[draggedFrom];
        const remainingItems = newList.filter((item, index) => index !== draggedFrom);

        newList = [
            ...remainingItems.slice(0, draggedTo),
            itemDragged,
            ...remainingItems.slice(draggedTo)
        ];

        if (draggedTo !== dragAndDrop.draggedTo){
            setDragAndDrop({
                ...dragAndDrop,
                updatedOrder: newList,
                draggedTo: draggedTo
            })
        }
    }

    const onDrop = (e) => {
        setShowSave(tagKeys !== dragAndDrop.updatedOrder);
        setTagKeys(dragAndDrop.updatedOrder);
        setDragAndDrop({
            ...dragAndDrop,
            draggedFrom: null,
            draggedTo: null,
            isDragging: false
        });
    }

    useEffect(() => {
        (async () => {
            const tagKeys = await getTagKeys(tag.id);
            setTagKeys(tagKeys)
        })();
    }, [tag]);

    const handleSaveOrder = async () => {
        const formData = new FormData();
        const orderArray = {};
        tagKeys.forEach((tagKey, index) => orderArray[tagKey.id] = index+1);

        formData.append('newOrder', JSON.stringify(orderArray));

        const result = await fetch(`/api/tags/${tag.id}/order-keys`, {
            method: "POST",
            body: formData
        }).then(res => res.json());

        if(result.success) {
            setShowSave(false);
        }
    }

    return (
        <div className="d-flex flex-column col-6">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h6>Translation Keys for tag: {tag.name}</h6>
                {showSave && <button className="btn btn-mondly btn-blue" onClick={handleSaveOrder}>Save order</button>}
            </div>
            <div className="tags-column">
                {tagKeys.map((tagKey, index) => (
                    <Link
                        to={{ pathname: `/keys`, search: `?key=${tagKey.text}` }}
                        data-position={index}
                        draggable="true"
                        onDragStart={onDragStart}
                        onDragOver={onDragOver}
                        onDrop={onDrop}
                        className={'tag-translation-key key-item d-flex align-items-center justify-content-between p-3 mb-2 text-decoration-none'}
                        key={index}>
                            <div className="d-flex flex-column">
                                <span className={"translation-key"}>{tagKey.text}</span>
                                <span className="translation-source">{tagKey.english_text}</span>
                            </div>
                            <i className="fas fa-arrows-alt-v"></i>
                    </Link>
                ))}
            </div>

        </div>
    )
}